/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Fade, Modal } from "@mui/material"
import { useState } from "react"
import PictureInfo from "../admin/lib/PictureInfo"

type ImageData = {
  data: string
  date: string
  latitude: number
  longitude: number
}

type Props = {
  imageData: ImageData
  width: number
}

export const PopImageView = (props: Props) => {
  const { imageData, width } = props
  const [open, setOpen] = useState<boolean>(false)

  return (
    <Box display="contents" justifyContent="center">
      <img src={imageData.data} width={width} onClick={() => setOpen(true)}/>
      <Modal
        className="flex justify-center items-center"
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
      >
        <Fade in={open} timeout={500}>
          <Box display="flex" justifyContent="center">
            <img
              src={imageData.data}
              alt="asd"
              style={{ maxHeight: "90%", maxWidth: "90%" }}
            />
            {
              imageData.latitude &&
                <Box ml={"-200px"} mt="auto">
                  <PictureInfo date={imageData.date} lat={imageData.latitude} lng={imageData.longitude} />
                </Box>
            }
          </Box>
        </Fade>
      </Modal>
    </Box>
  )
}
